module.exports = Object.freeze({
    USER_CONNECTED: 'user-connected',
    TOKEN_VALIDATION: 'token-validation',
    GET_TRANSLATIONS: 'get-translations',
    TRANSLATIONS: 'translations',
    NAMESPACE: 'webui',
    COLLECT_REPORTS_BY_FILTER_END: 'collect-reports-by-filter-end'
})